export var IdLibraryCategory;
(function (IdLibraryCategory) {
    IdLibraryCategory[IdLibraryCategory["MainFarm"] = 13] = "MainFarm";
    IdLibraryCategory[IdLibraryCategory["Upgrade"] = 56] = "Upgrade";
})(IdLibraryCategory || (IdLibraryCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/library/IdLibraryCategory.ts
// module id = 484
// module chunks = 3